export interface IBusinessCreditReportState {
    isLoading: boolean;
    creditReportData?: IBusinessCreditReportResponse[];
}

export const REQUEST_BUSINESS_CREDIT_REPORT = "REQUEST_BUSINESS_CREDIT_REPORT";
export const RECEIVE_BUSINESS_CREDIT_REPORT = "RECEIVE_BUSINESS_CREDIT_REPORT";

export interface IRequestBusinessCreditReportAction {
    type: typeof REQUEST_BUSINESS_CREDIT_REPORT;
}

export interface IReceiveBusinessCreditReportAction {
    creditReportData?: IBusinessCreditReportResponse[];
    type: typeof RECEIVE_BUSINESS_CREDIT_REPORT;
}

export type BusinessCreditReportTypes = IRequestBusinessCreditReportAction | IReceiveBusinessCreditReportAction;

export interface IBusinessCreditReportResponse {
    ReportID?: number;
    CreatedDate?: string;
    Previous_Report_Date?: string;
    RegistrationStatus?: any;
    Provider?: string;
    historyLength?: number;

    /*FOR UI PURPOSE*/
    uiData?: IUiData;
    reportPK?: string;
}

export interface BusinessCreditReportStatePII {
    businessCompanyReport?: IBusinessCompanyReport;
}

export interface IBusinessCompanyReport {
    company_details?: ICompanyDetails;
    corporate_officers?: ICorporateOfficer[];
    credit_inquiries?: ICreditInquiries[];
    commentary?: ICommentary;
    credit_score_and_limit?: ICreditScoreAndLimit;
    trade_payment_data?: ITradePaymentData;
    monthly_dbt_trends?: IMonthlyDBTTrend[];
    previous_monthly_dbt_trends?: IMonthlyDBTTrend[];
    legal_filings?: ILeagalFilings;
    active_tax_liens?: IActiveTaxLine[];
    active_judgements?: IActiveJudgement[];
    active_law_suites?: IActiveLawSuite[];
    uniform_commercial_code_finings?: IUniformCommercialCodeFining[];
    income_statement?: IIncomeStatement[];
    assets?: IAsset[];
    liabilities?: Iliability[];
    capital_structure?: ICapitalStructure[];
    key_ratios?: IKeyRatio[];
    group_structure?: IGroupStructure;
    business_licenses?: IBusinessLicense[];
}

export interface ICompanyDetails {
    company_name?: string;
    other_legal_name?: string;
    company_type?: string;
    address?: string;
    telephone_number?: string;
    company_status?: string;
    duns_number?: string;
    charter_number?: string;
    incorporated_date?: string;
    number_of_employees?: string;
    company_url?: string;
    possible_ofac?: boolean;
    company_id?: string;
    primary_sic_code_industry_classification?: string;
    primary_sic_code?: string[];
    primary_naics_code?: string[];
}

export interface ICorporateOfficer {
    contact_name?: string;
    contact_title?: string;
    address?: string;
    city?: string;
    state?: string;
    zip_code?: string;
}

export interface ICreditInquiries {
    number_of_inquiries?: string;
    week_start_date?: string;
}

export interface ICommentary {
    BankruptcyCommentary?: string;
    YearBusinessStartedCommentary?: string;
    NoBusinessSpenddataCommentary?: string;
    CompanyDbtInSameIndustryCommentary?: string;
    CompanyDbtInSameStateCommentary?: string;
    LegalFilingsCommentary?: string;
    TotalUccCommentary?: string;
    CautionaryUccCommentary?: string;
    GroupSizeCommentary?: string;
    RiskRatingCommentary?: string;
    CreditLimitCommentary?: string;
}

export interface ICreditScoreAndLimit {
    current_score?: string;
    current_rating?: string;
    current_risk_rating?: string;
    current_recommended_credit_limit?: string;
    previous_score?: string;
    previous_rating?: string;
    previous_risk_rating?: string;
    previous_recommended_credit_limit?: string;
    paydex_score?: string;
    trade_experience_count?: string;
    previous_paydex_score?: string;
    date_of_latest_rating_Change?: string;
}

export interface ITradePaymentData {
    dbt?: string;
    trade_lines?: string;
    current?: string;
    value_1_30?: string;
    value_31_60?: string;
    value_61_90?: string;
    value_91_plus?: string;
    total?: string;
}

export interface IMonthlyDBTTrend {
    month?: string;
    days_beyond_terms?: string;
}

export interface ILeagalFilings {
    bankruptcy?: boolean;
    judgements?: string;
    tax_lien_filing?: string;
    ucc_filing?: string;
    cautionary_ucc_filing?: string;
    sum?: ILeagalFillingsSum;
}

export interface IActiveTaxLine {
    date_filed?: string;
    filing_type?: string;
    filing_number?: string;
    amount?: string;
    jurisdiction?: string;
    action_type?: string;
}

export interface IActiveJudgement {
    date_filed?: string;
    filing_type?: string;
    case_number?: string;
    amount?: string;
    plaintiff?: string;
}

export interface IActiveLawSuite {
    date_filed?: string;
    filing_type?: string;
    case_number?: string;
    amount?: string;
    plaintiff?: string;
}

export interface IUniformCommercialCodeFining {
    date_filed?: string;
    expiration_date?: string;
    filing_number?: string;
    jurisdiction?: string;
    collateral?: string;
    status?: string;
}

export interface IIncomeStatement {
    date?: string;
    currency?: string;
    gross_sales?: string;
    adjustments_excise_tax_net_sales?: string;
    net_sales?: string;
    other_revenues?: string;
    total_revenues?: string;
    costs_goods_services_total_expenses?: string;
    operation_income?: string;
    selling_general_administrative_costs?: string;
    r_and_d_expense?: string;
    earning_before_interest_tax_depreciation?: string;
    depreciation_and_depletion?: string;
    amoritization?: string;
    imparements_fixed_assets_and_intangibles?: string;
    total_depreciation_depletion_amoritization?: string;
    operating_income_after_debt_and_amort?: string;
    unusual_exceptional_items?: string;
    earnings_before_interest_and_tax?: string;
    interest_income?: string;
    interest_expense?: string;
    net_interest?: string;
    other_financial_income_and_expenses?: string;
    earnings_before_tax?: string;
    income_taxes?: string;
    earnings_after_tax?: string;
    minority_interest?: string;
    date_filpreacquisition_profited?: string;
    other_after_tax_adjustments?: string;
    extraordinary_items_after_tax?: string;
    preferred_dividends?: string;
    net_profit?: string;
    ordinary_dividends?: string;
    dividend_share_capital_other?: string;
    preacquisition_profit?: string;
}

export interface IAsset {
    date?: string;
    currency?: string;
    cash_and_equivalent?: string;
    shot_term_investments?: string;
    accounts_receivable?: string;
    inventories?: string;
    prepayment_advances_other_current_assets?: string;
    current_assets?: string;
    property_plant_equipment?: string;
    net_property_plant_equipment?: string;
    goodwill?: string;
    other_intangibles?: string;
    goodwill_and_intangibles?: string;
    total_assets?: string;
    redeemable_preferred_shares?: string;
}

export interface Iliability {
    date?: string;
    currency?: string;
    taxes_payable?: string;
    other_current_liabilities?: string;
    total_current_liabilities?: string;
    long_term_debt?: string;
    long_term_convertable_debt?: string;
    lease_obligation?: string;
    total_long_term_interest_bearing_debt?: string;
    minotity_interest?: string;
    deferred_taxes?: string;
    provisions?: string;
    total_liabilities_and_debt?: string;
    preferred_shares?: string;
    common_stock_shares?: string;
    participation_shares?: string;
    share_captial?: string;
    additiona_paid_in_captial?: string;
    sharegolders_reserve?: string;
    retained_earnings?: string;
    treasury_stock?: string;
    other_equity?: string;
    total_shareholders_equity?: string;
    total_liabilities_and_equity?: string;
}

export interface ICapitalStructure {
    date?: string;
    accounts_payable?: string;
    short_term_debt?: string;
    current_portion_long_term_debt?: string;
}

export interface IKeyRatio {
    date?: string;
    growth_in_net_turnover?: string;
    growth_in_noplat?: string;
    growth_in_shareholders_equity?: string;
    debt_to_capital_at_book?: string;
}

export interface IGroupStructure {
    group?: string;
    linkages?: string;
    ultimate_holding_company?: string;
    company_name?: string;
}

export interface IBusinessLicense {
    type?: string;
    status?: string;
    body_name?: string;
    jurisdiction?: string;
    start_date?: string;
    end_date?: string;
}

export interface ILeagalFillingsSum {
    currency?: string;
    text?: string;
}

export interface IUiData {
    currentDate?: string;
    previousDate?: string;
}
